var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 514,
    width: 514,
    y: -1,
    x: -1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    id: "svg_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "svg_3",
    d: "m402.048,203.157c-14.827,-73.856 -80.661,-128.491 -156.715,-128.491c-88.235,0 -160,71.765 -160,160c0,3.605 0.149,7.296 0.469,11.2c-48.149,5.121 -85.802,45.974 -85.802,95.467c0,52.928 43.072,96 96,96l298.667,0c64.704,0 117.333,-52.629 117.333,-117.333c0,-61.675 -47.829,-112.384 -109.952,-116.843zm-7.381,212.843l-298.667,0c-41.173,0 -74.667,-33.493 -74.667,-74.667c0,-41.173 33.493,-74.667 73.963,-74.688c0.469,0.064 1.749,0.192 2.24,0.213c3.051,-0.277 6.101,-1.28 8.192,-3.605c2.069,-2.347 3.008,-5.483 2.56,-8.576c-1.109,-7.68 -1.621,-14.016 -1.621,-20.011c0,-76.458 62.208,-138.666 138.666,-138.666c68.501,0 127.445,51.157 137.109,118.997c0.747,5.355 6.976,9.088 12.224,9.003c52.928,0 96,43.072 96,96s-43.071,96 -95.999,96z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svg_4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_10"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_11"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_12"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_13"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_14"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_15"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_16"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_17"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svg_18"
  }), /*#__PURE__*/React.createElement("text", {
    fontStyle: "normal",
    fontWeight: "normal",
    transform: "rotate(-0.0889623, 256.004, 256) matrix(5.94416, 0, 0, 5.94966, -1005.94, -1508.51)",
    xmlSpace: "preserve",
    textAnchor: "start",
    fontFamily: "'Open Sans SemiBold'",
    fontSize: 24,
    id: "svg_20",
    y: 305.90583,
    x: 195.24686,
    opacity: "undefined",
    fillOpacity: "null",
    strokeOpacity: "null",
    strokeDasharray: "null",
    strokeWidth: 0,
    stroke: "#000",
    fill: "#000000"
  }, "CO"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCo);
export default __webpack_public_path__ + "static/media/CO.4ad9d11f686955e77eebc53b1df05620.svg";
export { ForwardRef as ReactComponent };